<div class="container">
    <h1 class="page-title"
    [helpCenterButton]="viewPermissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="viewPermissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-circle-question"></i></span>FAQ</h1>
  <p-card>
    <form [formGroup]="searchForm">
      <div class="p-fluid formgrid grid">
        <div class="field col-12 md:col-4">
          <label>{{ 'FaqMaintenance.Search.Facility' | translate }}</label>
          <laas-facility-dropdown
            formControlName="facility"
            [isMultiple]="true"
            [showFilter]="true"
            [showToggleAll]="true"
            (onOptionDataChange)="filterByFacility($event)"
          >
          </laas-facility-dropdown>
        </div>
        <div class="field md:col-8"></div>
        <div class="field col-12 md:col-4">
          <div class="p-inputgroup">
            <input type="text" pInputText formControlName="keyword" placeholder="Keyword">
            <button type="button" pButton pRipple icon="fas fa-search" (click)="searchBtnClick($event)" ></button>
          </div>
        </div>
      </div>
    </form>
    <p-accordion [multiple]="true">
      <div *ngFor="let faq of faqList" class="mt-2">
        <p-accordionTab
          header="{{ faq.question }} &emsp; &emsp;
          {{ 'FaqMaintenance.Search.ApplyFacility' | translate }}
          {{ faq.facility }}"
          [selected]="true">

          <div class="announcement-content" [innerHTML]="faq.answer | safeHtml"></div>

        </p-accordionTab>
      </div>
    </p-accordion>
  </p-card>
</div>
<help-dock
  [permissionCode]="viewPermissionCode"
  [lang]="currentLang">
</help-dock>
